module.exports = __webpack_public_path__ + "static/media/1.b4b23921.jpg";